export const isProd = import.meta.env.VITE_APP_PAYMENT_ENV === 'production';
export const isTouchDevice = window.matchMedia('(hover: none)').matches;

export const OPTION = {
  DECK: 'deck',
  COMBO: 'combo'
} as const;

export type OPTION = (typeof OPTION)[keyof typeof OPTION];
